const news_data = [
	{
		id: 'rent-a-car-alternatives-sofia',
		text: 'blog-1.description',
		title: 'blog-1.title',
		date: '16/10/2023',
		time: '3',
	},
	{
		id: 'holidays-to-bulgaria-travel-guide',
		text: 'blog-2.description',
		title: 'blog-2.title',
		date: '16/10/2023',
		time: '4',
	},
	{
		id: 'avoid-taxi-scams-sofia',
		text: 'blog-3.description',
		title: 'blog-3.title',
		date: '16/10/2023',
		time: '3',
	},

];

const single_news_data = [
	{
		id: 'rent-a-car-alternatives-sofia',
		title: 'blog-1.title',
		blogId: 'blog-1',
		image: '/images/blog/post_1.jpg',
		date: '16/11/2023',
		time: '3',
		authorName: 'Miroslav Ilyovski',
	},
	{
		id: 'holidays-to-bulgaria-travel-guide',
		title: 'blog-2.title',
		blogId: 'blog-2',
		image: '/images/blog/post_2.jpg',
		date: '08/12/2023',
		time: '3',
		authorName: 'Miroslav Ilyovski',
	},

];

export { news_data, single_news_data };
